var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelPopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0348 23.9707C29.7502 23.9707 29.5195 24.2013 29.5195 24.4859V34.2236C29.5195 34.508 29.7502 34.7388 30.0348 34.7388C30.3193 34.7388 30.55 34.508 30.55 34.2236V24.4859C30.55 24.2013 30.3193 23.9707 30.0348 23.9707Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9547 23.9707C23.6701 23.9707 23.4395 24.2013 23.4395 24.4859V34.2236C23.4395 34.508 23.6701 34.7388 23.9547 34.7388C24.2393 34.7388 24.4699 34.508 24.4699 34.2236V24.4859C24.4699 24.2013 24.2393 23.9707 23.9547 23.9707Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5239 22.5496V35.2436C19.5239 35.9939 19.799 36.6985 20.2796 37.204C20.758 37.711 21.4237 37.9988 22.1205 38H31.8686C32.5656 37.9988 33.2314 37.711 33.7095 37.204C34.1901 36.6985 34.4653 35.9939 34.4653 35.2436V22.5496C35.4206 22.296 36.0397 21.3731 35.9119 20.3927C35.7839 19.4126 34.9489 18.6794 33.9603 18.6792H31.3224V18.0352C31.3254 17.4936 31.1113 16.9736 30.7279 16.591C30.3445 16.2086 29.8236 15.9956 29.2821 16.0001H24.7071C24.1655 15.9956 23.6446 16.2086 23.2612 16.591C22.8778 16.9736 22.6637 17.4936 22.6667 18.0352V18.6792H20.0288C19.0402 18.6794 18.2052 19.4126 18.0772 20.3927C17.9494 21.3731 18.5685 22.296 19.5239 22.5496ZM31.8686 36.9696H22.1205C21.2396 36.9696 20.5543 36.2128 20.5543 35.2436V22.5949H33.4348V35.2436C33.4348 36.2128 32.7495 36.9696 31.8686 36.9696ZM23.6971 18.0352C23.6937 17.7669 23.7992 17.5087 23.9896 17.3193C24.1798 17.1299 24.4386 17.0259 24.7071 17.0305H29.2821C29.5505 17.0259 29.8094 17.1299 29.9995 17.3193C30.1899 17.5085 30.2954 17.7669 30.292 18.0352V18.6792H23.6971V18.0352ZM20.0288 19.7097H33.9603C34.4725 19.7097 34.8877 20.1249 34.8877 20.6371C34.8877 21.1493 34.4725 21.5645 33.9603 21.5645H20.0288C19.5166 21.5645 19.1014 21.1493 19.1014 20.6371C19.1014 20.1249 19.5166 19.7097 20.0288 19.7097Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9947 23.9707C26.7101 23.9707 26.4795 24.2013 26.4795 24.4859V34.2236C26.4795 34.508 26.7101 34.7388 26.9947 34.7388C27.2793 34.7388 27.5099 34.508 27.5099 34.2236V24.4859C27.5099 24.2013 27.2793 23.9707 26.9947 23.9707Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelPopIcon);
export default __webpack_public_path__ + "static/media/del_pop_icon.f45c9fdd62f12e500f5cc03b9b7c3964.svg";
export { ForwardRef as ReactComponent };